var _path, _ellipse, _ellipse2, _ellipse3, _ellipse4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBilletter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "currentColor",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.322,1.863a2.324,2.324,0,0,1-4.556-.89L21.909.61a2.331,2.331,0,0,1-2,1.749V0h-4a2.486,2.486,0,0,1-2.475,2.361A2.486,2.486,0,0,1,10.966,0H8.947A2.486,2.486,0,0,1,6.472,2.361,2.486,2.486,0,0,1,4,0H0V31.969H3.995a2.479,2.479,0,0,1,4.954,0h2.016a2.479,2.479,0,0,1,4.954,0h3.995V28.642a2.328,2.328,0,0,1,2.7,2.64L26.29,32,32,2.581Zm-10.4,28.108h-.534a4.462,4.462,0,0,0-7.431-.7,4.462,4.462,0,0,0-7.431.7H1.991V2h.546A4.469,4.469,0,0,0,6.472,4.359,4.456,4.456,0,0,0,9.957,2.678a4.456,4.456,0,0,0,3.485,1.681A4.469,4.469,0,0,0,17.376,2h.546V29.971Zm6.794-.314-.3-.058a4.278,4.278,0,0,0-4.505-2.958V13.166a1.47625,1.47625,0,0,0,.466.082,1.5,1.5,0,0,0,0-3,1.47625,1.47625,0,0,0-.466.082V4.356a4.285,4.285,0,0,0,2.41-.907,4.3,4.3,0,0,0,7.035.651l.307.06Z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 4.978,
    cy: 11.489,
    rx: 1.494,
    ry: 1.499
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.957,
    cy: 11.489,
    rx: 1.494,
    ry: 1.499
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 14.935,
    cy: 11.489,
    rx: 1.494,
    ry: 1.499
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 25.024,
    cy: 12.661,
    rx: 1.494,
    ry: 1.499
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBilletter);
export default __webpack_public_path__ + "static/media/Billetter.0f4f9162161905697f4fa0bf4bdfb6df.svg";
export { ForwardRef as ReactComponent };